import { getAvailabilitySlotsForRange, MatchingProfileData } from '@uplift/api';
import { useTimezone } from '@uplift/contexts';
import { CalendarDateService } from '@uplift/services';
import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';

export const useAvailability = (providers: MatchingProfileData[], patientId: string) => {
  const timezone = useTimezone();

  const { from, to } = useMemo(() => {
    const from = CalendarDateService.date().tz(timezone).startOf('day').utc();
    const to = from.add(30 + 1, 'days');

    return {
      from: from.format(),
      to: to.format(),
    };
  }, [ timezone ]);

  const slotQueries = useQueries({
    queries: providers?.map(x => ({
      queryKey: [ 'availability-slots', x.user.id, patientId, from, to, timezone ],
      queryFn: async () => ({
        providerId: x.user.id,
        slots: await getAvailabilitySlotsForRange({
          datetime_from: from,
          datetime_to: to,
          provider_id: x.user.id,
          patient_id: patientId,
        }),
      })
    })) ?? []
  });

  const slots = useMemo(
    () => slotQueries.map(x => ({
      providerId: x?.data?.providerId,
      slots: x?.data?.slots?.slots.map(s => CalendarDateService.date(s).utc().format()) ?? []
    })),
    [ slotQueries ]
  );

  return {
    slotsLoading: slotQueries.some(x => x.isLoading),
    slots,
  };
};
